"use client";

import LockIcon from "public/next-public/common/icons/lock-icon.svg";
import style from "./secureCheckout.module.scss";

export default function SecureCheckout({}: SecureCheckoutProps) {
  return (
    <div className={style.secureCheckout}>
      <LockIcon className={style.lock} aria-hidden />
      <div className={style.text}>
        <strong>Secure Shopping Guaranteed.</strong>
        <span>Your shopping experience is always safe and secure.</span>
      </div>
    </div>
  );
}

export type SecureCheckoutProps = Record<string, never>;
